var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"log-out",on:{"click":function($event){return _vm.Logout()}}},[_vm._v(" Sair ")])
}
var staticRenderFns = []

export { render, staticRenderFns }